import React from 'react';
import { Box, Typography } from '@mui/material';

import { PaperBoxStyles } from '@/components/styles';

interface CreatedUpdatedInfoSectionProps {
  createdAt?: string;
  createdUser?: string;
  updatedAt?: string;
  updatedUser?: string;
}

export const CreatedUpdatedInfoSection: React.FC<CreatedUpdatedInfoSectionProps> = ({
  createdAt,
  createdUser,
  updatedAt,
  updatedUser,
}) => {
  const formatDateTime = (dateString?: string): string => {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      return date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    } catch {
      return dateString;
    }
  };

  return (
    <PaperBoxStyles elevation={1} sx={{ mt: 2, paddingBottom: '32px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {/* Created Info */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant='body2'
            sx={{
              minWidth: 120,
              fontWeight: 'medium',
              color: 'text.secondary',
            }}
          >
            登録者／登録日時:
          </Typography>
          <Typography variant='body2' sx={{ ml: 2 }}>
            {createdUser && createdAt ? `${createdUser} ${formatDateTime(createdAt)}` : '情報なし'}
          </Typography>
        </Box>

        {/* Updated Info */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant='body2'
            sx={{
              minWidth: 120,
              fontWeight: 'medium',
              color: 'text.secondary',
            }}
          >
            更新者／更新日時:
          </Typography>
          <Typography variant='body2' sx={{ ml: 2 }}>
            {updatedUser && updatedAt ? `${updatedUser} ${formatDateTime(updatedAt)}` : '情報なし'}
          </Typography>
        </Box>
      </Box>
    </PaperBoxStyles>
  );
};
